//
// Copyright (c) 2024 Comcast
//

import PropTypes from 'prop-types'
import ScrollArea from 'components/Shared/ScrollArea/Index'
import styled, { css } from 'styled-components'

const StyledScrollArea = styled(ScrollArea)`
  overflow-y: auto;
`

// padding-bottom is required to prevent scrolling when body height
// is too small (one line in confirmation dialog)
const StyledModalBody = styled(StyledScrollArea)`
  ${props => !props.$noMargins && css`
    margin: 40px 32px 32px 32px;
    padding-bottom: 4px;
  `}

  ${props => props.$noMargins && css`
    margin: 0;
    padding: 0;
  `}
`

const ModalBody = ({ children, className, noMargins }) => {
  return (
    <StyledModalBody
      data-test='modal-body'
      className={`_modal_scroll ${className}`}
      $noMargins={noMargins}
    >
      {children}
    </StyledModalBody>
  )
}

ModalBody.propTypes = {
  children: PropTypes.node,
  noMargins: PropTypes.bool,
}

export default ModalBody
